import { useEffect, useState } from 'react';
import { getLaboratories, postLaboratories, putLaboratoryResult, getLaboratoryResult, getLaboratoryResults, getLaboratoryResultHistory } from '../../../api/medicalRecord';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';

export const useLaboratories = (medicalRecordNumber, entryId) => {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        medicalRecordNumber: medicalRecordNumber ? medicalRecordNumber : 0,
        entryId: entryId ? entryId : 0,
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        },
        actual: false
    });
    const [reload, setReload] = useState(false);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                setReload(false);
                setIsLoading(true);
                const paginatedItems = await getLaboratories(query);

                if (isSubscribed) {
                    setTotalSize(paginatedItems.data.count);
                    setData(paginatedItems.data.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setTotalSize(0);
                setData([]);
            }
        }

        fetchData();

        return () => isSubscribed = false;
    }, [query, reload]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        var newQuery = JSON.parse(JSON.stringify(query));

        switch (type) {
            case 'pagination': {
                newQuery.pagination.page = page;
                newQuery.pagination.sizePerPage = sizePerPage;
                setQuery(newQuery);
                break;
            }
            case 'sort': {
                newQuery.sort.sortField = sortField;
                newQuery.sort.sortOrder = sortOrder;
                setQuery(newQuery);
                break;
            }
        }
    }

    return [data, query, totalSize, isLoading, handleTableChange, setReload];
}

export const useLaboratory = (entryId, id) => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        let isSubscribed = true;
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const res = await getLaboratoryResult(entryId, id);
                //console.log("useLaboratory", res.data)

                if (isSubscribed) {
                    setData(res.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setData(null);
            }
        }

        if (id)
            fetchData();

        return () => isSubscribed = false;
    }, [entryId, id]);

    const create = (entryId, data) => {
        return postLaboratories(entryId, data);
    }

    const update = (entryId, id, data) => {
        return putLaboratoryResult(entryId, id, data);
    }

    return [data, isLoading, create, update];
}

export const useLaboratoryResults = () => {
    const fetchData = (laboratoryId) => {
        try {
            return getLaboratoryResults(laboratoryId);
        } catch (error) {
            HandleApiError(error);
        }
    }
    return [fetchData];
}

export const useLaboratoryResultHistory = () => {
    const fetchData = (laboratoryId) => {
        try {
            return getLaboratoryResultHistory(laboratoryId);
        } catch (error) {
            HandleApiError(error);
        }
    }
    return [fetchData];
}